"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _createForOfIteratorHelper = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var LogLevel_1 = require("../logger/LogLevel");

var AsyncScheduler_1 = require("../scheduler/AsyncScheduler");
/**
 * A task that wraps another task and ensures it is run only once,
 * regardless of how many times `run` is called.
 *
 * This allows you to implement a kind of barrier synchronization.
 */


var OnceTask = /*#__PURE__*/function () {
  function OnceTask(logger, task, dependencies) {
    _classCallCheck(this, OnceTask);

    this.logger = logger;
    this.task = task;
    this.dependencies = dependencies; // Whether we have canceled.

    this.canceled = false;
  }

  _createClass(OnceTask, [{
    key: "name",
    value: function name() {
      return "".concat(this.task.name(), " (once)");
    }
  }, {
    key: "cancel",
    value: function cancel() {
      var _this = this;

      // We want to preserve one interesting property: the deepest dependency that hasn't
      // already finished or been canceled is the first to be canceled, and its failure
      // will propagate back up the promise chain.
      //
      // We can't just cancel ourselves with cancelPromise -- we will cut off the rest of
      // the tree. Nor can we necessarily do it on the same event loop tick, because the
      // cancelation might be subtly async.
      //
      // Instead, we immediately cancel each dependency, and then we cancel the current
      // task (if it's running), and then we cancel via our promise escape hatch if needed.

      /* istanbul ignore if */
      if (this.canceled) {
        return;
      }

      if (this.dependencies) {
        var _iterator = _createForOfIteratorHelper(this.dependencies),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var dep = _step.value;
            dep.cancel();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } // Do this on the next tick so that our canceled dependencies cascade.


      this.logger.info("Canceling ".concat(this.name()));
      AsyncScheduler_1.default.nextTick(function () {
        return _this.task.cancel();
      });
      this.canceled = true;

      if (this.cancelPromise) {
        AsyncScheduler_1.default.nextTick(function () {
          return _this.cancelPromise(new Error("canceling ".concat(_this.name())));
        });
      }
    }
  }, {
    key: "logDependencies",
    value: function logDependencies() {
      if (this.logger.getLogLevel() > LogLevel_1.default.INFO) {
        return;
      }

      if (!this.dependencies) {
        return;
      }

      var names = this.dependencies.filter(function (d) {
        return d;
      }).map(function (d) {
        return d.name();
      }).join(', ');
      this.logger.info("".concat(this.task.name(), " waiting for dependencies: ").concat(names));
    }
  }, {
    key: "run",
    value: function run() {
      var _this2 = this;

      if (this.promise) {
        return this.promise;
      }

      var dependencies = this.dependencies ? Promise.all(this.dependencies.map(function (d) {
        return d === null || d === void 0 ? void 0 : d.run();
      })) : Promise.resolve();
      this.logDependencies();
      this.ongoing = dependencies.then(function () {
        return _this2.task.run();
      });
      return this.promise = new Promise(function (resolve, reject) {
        _this2.cancelPromise = reject;

        _this2.ongoing.then(resolve).catch(reject);
      });
    }
  }, {
    key: "setParent",
    value: function setParent(parentTask) {
      this.task.setParent(parentTask);
    }
  }]);

  return OnceTask;
}();

exports.default = OnceTask;